/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyMonero = createReactComponent("currency-monero", "IconCurrencyMonero", [
  ["path", { d: "M3 18h3v-11l6 7l6 -7v11h3", key: "svg-0" }]
]);

export { IconCurrencyMonero as default };
//# sourceMappingURL=IconCurrencyMonero.js.map
